import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from '@mui/material';

export interface SignupLoginPromptProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

/**
 * 未ログインユーザーに「気になる」やブックマーク等の操作を試行された際の登録/ログイン誘導モーダル。
 * session-bookmark など他のユニットでも再利用される共通コンポネント。
 */
export const SignupLoginPrompt: React.FC<SignupLoginPromptProps> = ({
  open,
  onClose,
  title = 'ユーザー登録が必要です',
  message = '「気になる」を保存するには、ユーザー登録または既存アカウントでのログインが必要です。',
}) => {
  const location = useLocation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="signup-login-prompt-title"
      data-testid="signup-login-prompt"
    >
      <DialogTitle id="signup-login-prompt-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="signup-login-prompt-close">
          閉じる
        </Button>
        <Button
          component={RouterLink}
          to="/login"
          replace
          state={{ from: location }}
          onClick={onClose}
          data-testid="signup-login-prompt-login"
        >
          ログイン
        </Button>
        <Button
          component={RouterLink}
          to="/signup"
          replace
          state={{ from: location }}
          variant="contained"
          onClick={onClose}
          data-testid="signup-login-prompt-signup"
        >
          ユーザー登録
        </Button>
      </DialogActions>
    </Dialog>
  );
};
